module.exports = __webpack_public_path__ + "3c80502f4d5200a61eacbf17a8ab6fd2.ttf";